import React from 'react';
import { Box, Typography, useTheme } from '@mui/material';
import RocketLaunchIcon from '@mui/icons-material/RocketLaunch';

const MissionSlide: React.FC = () => {
  const theme = useTheme();
  
  return (
    <Box sx={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      color: theme.palette.text.primary,
      padding: 4,
      height: '100%',
    }}>
      <RocketLaunchIcon sx={{ fontSize: 120, mb: 4, color: theme.palette.warning.main }} />

      <Typography
        variant="h2"
        align="center"
        sx={{
          mb: 3,
          fontWeight: 'bold',
          color: theme.palette.warning.main,
          fontSize: { xs: '3rem', sm: '4rem', md: '5rem' },
        }}
      >
        Our Mission
      </Typography>
      
      <Typography 
        variant="h3" 
        align="center" 
        sx={{ 
          mb: 4,
          maxWidth: '900px',
          lineHeight: 1.5,
          fontSize: { xs: '2rem', sm: '2.5rem', md: '3rem' },
          fontWeight: 600,
          color: theme.palette.text.primary,
        }}
      >
        The Human-in-the-Loop AI Platform
      </Typography>
      
      <Typography 
        variant="h5" 
        align="center" 
        sx={{ 
          maxWidth: '800px',
          color: theme.palette.text.secondary,
          lineHeight: 1.8,
          fontSize: { xs: '1.2rem', sm: '1.4rem', md: '1.6rem' },
        }}
      >
        Oppy is the first platform where you can launch and manage AI employees with 
        access to phone, email, chat, your CRM, calendars, and 60+ other tools—all in a few clicks. 
        Build your dream team of AI employees before you even write a job description for humans.
        We&apos;re powering the next generation of entrepreneurs to build the future.
      </Typography>
    </Box>
  );
};

export default MissionSlide;
